<!-- TEMPLATE -->
<template>
  <div class="dean-form-row">
    <div class="row">
      <div class="small-6 medium-6 large-6 hd-6 columns">
        <p class="input-label">{{ label }}</p>
        <!-- {{ label | regularCaseString | capitalize  }} -->
      </div>
      <div class="small-6 medium-6 large-6 hd-6 columns">
        <dean-input-field
          :id="id"
          :type="deanInputFieldType"
          @input="deanInputField"
          :value="value"
          :validation="validation"
          :tab-index="tabIndex"
          :required-field="requiredField"
          :disabled="disabled"
          :readonly="readonly"
        >
          <slot>{{ label }}</slot>
        </dean-input-field>
      </div>
    </div>
  </div>
</template>

<!-- SCRIPT -->
<script lang="ts">
// VUE
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

// COMPONENTS
import deanInputField from './deanInputField.vue';

@Component({
  components: {
    deanInputField
  },

  // FILTERS
  filters: {
    capitalize(value: string) {
      if (!value) return '';
      const text = value.toString();
      return text.charAt(0).toUpperCase() + text.slice(1);
    },
    regularCaseString(value: string) {
      if (!value) return '';
      const text = value.toString();
      return text.replace(/([A-Z])/g, ' $1');
    }
  }
})
export default class deanFormRow extends Vue {
  //PROPS
  @Prop({ default: '' }) value!: string;
  @Prop({ default: true }) text!: boolean;
  @Prop({ default: false }) disabled!: boolean;
  @Prop({ default: false }) readonly!: boolean;
  @Prop({ default: false }) password!: boolean;
  @Prop({ default: false }) tel!: boolean;
  @Prop({ default: false }) number!: boolean;
  @Prop({ default: false }) warning!: boolean;
  @Prop({ default: false }) requiredField!: boolean;
  @Prop({ default: '' }) type!: string;
  @Prop({ default: '' }) label!: string;
  @Prop({ default: '' }) validation!: string;
  @Prop({ default: '' }) id!: string;
  @Prop() tabIndex!: number;

  // COMPUTED
  get deanInputFieldType() {
    let value = 'text';
    if (this.text) value = `text`;
    if (this.password) value = `password`;
    if (this.number) value = `number`;
    if (this.tel) value = `tel`;
    if (this.type) {
      value = `${this.type}`;
    }
    return value;
  }

  // METHODS
  deanInputField(value: string) {
    const inputValue = {
      id: this.id,
      value: value,
      type: this.type
    };
    this.$emit('input', inputValue);
  }
}
</script>
<!-- STYLE -->
<style lang="scss" scoped>
// IMPORT
@import '../scss/vars';

.input-label {
  padding-left: 20px;
}
</style>
